import { useState, useEffect } from 'react'
import {
  List,
  SimpleForm,
  TextInput,
  Datagrid,
  Edit,
  Create,
  TextField,
  ReferenceInput,
  SelectInput,
  required,
  FormDataConsumer,
  useDataProvider,
} from 'react-admin'
import { ExtraPagination } from './utils'

export const RoutingConfigList = (props) => (
  <List
    bulkActionButtons={false}
    exporter={false}
    pagination={<ExtraPagination />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField source="front_tag_id" label="Id Tag Front" />
      <TextField source="front_tag" label="Tag Front" />
      <TextField source="routing_type" label="Règle" />
      <TextField source="targets" label="Cible" />
    </Datagrid>
  </List>
)

export const RoutingConfigCreate = (props) => {
  //We fetch manually front tags because we want to store tag id, but also tag name, so that rules are readable by mada
  //and it's not possible with ReferenceInput
  const [tags, setTags] = useState([])
  const dataProvider = useDataProvider()

  useEffect(() => {
    dataProvider
      .getList('front_tags', { pagination: {}, sort: {}, filter: {} })
      .then((response) => {
        setTags(response.data)
      })
      .catch((error) => {
        console.log(error.message)
        alert(error.message)
      })
  }, [])

  return (
    <Create {...props}>
      <SimpleForm variant="outlined">
        <SelectInput source="front_tag_id" label="Front Tag" choices={tags} />
        <SelectInput
          source="routing_type"
          label="Routage emails Front"
          choices={[
            { id: 'Gestionnaire', name: 'Gestionnaire' },
            { id: 'Process Owner', name: 'Process Owner' },
            { id: 'Comptable', name: 'Comptable' },
          ]}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (
              formData.front_tag_id !== null &&
              formData.front_tag_id !== undefined &&
              tags.length > 0
            ) {
              formData.front_tag = tags.filter(
                (t) => t.id === formData.front_tag_id
              )[0].name
            }

            if (formData.routing_type !== 'Process Owner') {
              return null
            }
            return (
              <ReferenceInput
                label="Process"
                source="process_id"
                reference="process"
              >
                <SelectInput optionText="name" />
              </ReferenceInput>
            )
          }}
        </FormDataConsumer>
      </SimpleForm>
    </Create>
  )
}

export const RoutingConfigEdit = (props) => {
  //We fetch manually front tags because we want to store tag id, but also tag name, so that rules are readable by mada
  //and it's not possible with ReferenceInput
  const [tags, setTags] = useState([])
  const dataProvider = useDataProvider()

  useEffect(() => {
    dataProvider
      .getList('front_tags', { pagination: {}, sort: {}, filter: {} })
      .then((response) => {
        setTags(response.data)
      })
      .catch((error) => {
        console.log(error.message)
        alert(error.message)
      })
  }, [])

  return (
    <Edit {...props}>
      <SimpleForm variant="outlined">
        <SelectInput source="front_tag_id" label="Front Tag" choices={tags} />
        <SelectInput
          source="routing_type"
          label="Routage emails Front"
          choices={[
            { id: 'Gestionnaire', name: 'Gestionnaire' },
            { id: 'Process Owner', name: 'Process Owner' },
            { id: 'Comptable', name: 'Comptable' },
          ]}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (
              formData.front_tag_id !== null &&
              formData.front_tag_id !== undefined &&
              tags.length > 0
            ) {
              formData.front_tag = tags.filter(
                (t) => t.id === formData.front_tag_id
              )[0].name
            }

            if (formData.routing_type !== 'Process Owner') {
              return null
            }
            return (
              <ReferenceInput
                label="Process"
                source="process_id"
                reference="process"
              >
                <SelectInput optionText="name" />
              </ReferenceInput>
            )
          }}
        </FormDataConsumer>
      </SimpleForm>
    </Edit>
  )
}
